import React from "react";
import { useSelector } from "react-redux";

import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { ConfirmDialog } from ".";
import { styled } from "@material-ui/core/styles";
import { spacing } from "@material-ui/system";
import MuiButton from "@material-ui/core/Button";
import { useDispatch } from "../../../../state";
import { buttonSubmitted } from "../../../../lib/helpers";

interface Props {
  attribute: string;
  myValue?: string;
  oldValue?: string;
  myBrand?: string;
  myBrandId?: number;
  id?: number;
  groupId?: number;
  rawAttribute?: string;
  Add_Edit_Delete: string;
  color: any;
  editName?: any;
  editBrand?: any;
  right?: any;
  disabled: boolean;
  caseBackCategory?: string;
  path?: string;
  siteId?: number;
  shipData?: any;
  checked2?: any;
  onSuccess?: () => void;
}
const Button = styled(MuiButton)(spacing);

export function ConfirmButton(props: Props) {
  const siteId = useSelector((state: any) => state.scopes.site_id);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [added, setAdded] = React.useState(false);

  const handleClickOpen = () => {
    if (props.Add_Edit_Delete === "add") {
      buttonSubmitted({
        Add_Edit_Delete: props.Add_Edit_Delete,
        rawAttribute: props.rawAttribute,
        myValue: props.myValue,
        myBrandId: props.myBrandId,
        category: undefined,
        id: props.id,
        attribute: props.attribute,
        dispatch,
        siteId,
        shipData: props.shipData,
        setNewFormik: undefined,
        silent: true,
      });
      if (props.onSuccess) props.onSuccess();
      setAdded(true);
      setTimeout(() => setAdded(false), 2000);
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (added) {
    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4, color: "#2e7d32", fontSize: 14, fontWeight: 500, padding: "10px 8px" }}>
        <CheckCircleOutlineIcon style={{ fontSize: 20, color: "#2e7d32" }} />
        Attribute Added
      </span>
    );
  }

  return (
    <span>
      <Button
        variant={props.checked2 ? "outlined" : "text"}
        color={props.color}
        onClick={handleClickOpen}
        disabled={props.disabled}
        size="large"
      >
        {props.Add_Edit_Delete === "delete" ? (
          <DeleteIcon style={{ color: "#c62828" }} />
        ) : (
          (props.Add_Edit_Delete === "edit" ? "Save" : props.Add_Edit_Delete) + " " + props.attribute
        )}
      </Button>
      <ConfirmDialog
        right={props.right}
        editBrand={props.editBrand}
        attribute={props.attribute}
        myValue={props.myValue}
        oldValue={props.oldValue}
        myBrand={props.myBrand}
        myBrandId={props.myBrandId}
        caseBackCategory={props.caseBackCategory}
        open={open}
        setOpen={setOpen}
        onClose={handleClose}
        rawAttribute={props.rawAttribute}
        Add_Edit_Delete={props.Add_Edit_Delete}
        id={props.id}
        groupId={props.groupId}
        editName={props.editName}
        path={props.path}
        siteId={siteId}
        shipData={props.shipData}
        onSuccess={props.onSuccess}
      />
    </span>
  );
}
